/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export class WidgetConstants {
}
WidgetConstants.SHOW_IN_COLLAPSED_MENU_ATTRIBUTE_KEY = 'show-in-collapsed-menu';
WidgetConstants.SHOW_IN_MOBILE_VIEW_ATTRIBUTE_KEY = 'show-in-mobile-view';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoid2lkZ2V0LmNvbnN0YW50cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9zaGFyZWQvbWljcm8tZnJvbnRlbmRzL3dpZGdldHMvd2lkZ2V0LmNvbnN0YW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7R0FFRztBQUNILE1BQU0sT0FBTyxlQUFlOztBQUNELG9EQUFvQyxHQUFHLHdCQUF3QixDQUFDO0FBQ2hFLGlEQUFpQyxHQUFHLHFCQUFxQixDQUFDIn0=